import script from "./default.vue?vue&type=script&setup=true&lang=js"
export * from "./default.vue?vue&type=script&setup=true&lang=js"

import "./default.vue?vue&type=style&index=0&id=94edfb14&lang=css"

const __exports__ = script;

export default __exports__